module.exports = __webpack_public_path__ + "img/api-integrations.6bdceed9.jpg";